module.exports = __webpack_public_path__ + "0f1243cb52c78bdf25dc4cdf88118931.pdf";